import styled from 'styled-components'
import { iPadUp } from './mediaQueries'

const MobileOnly = styled.span`
  display: inline-block;
  ${iPadUp} {
    display: none;
  }
`

export default MobileOnly
